export default class GestureAbstract {
  constructor (canvas) {
    this.canvas = canvas;

    // real_x/y ignores grid-snap value
    this.r_start_x = null;
    this.r_start_y = null;

    this.start_x = null;
    this.start_y = null;
  }

  init (mouse_x, mouse_y, mouse_target, right_click, event) {
    const current_zoom = this.canvas.getZoom();

    this.r_start_x = mouse_x / current_zoom;
    this.r_start_y = mouse_y / current_zoom;

    this.start_x = this.r_start_x;
    this.start_y = this.r_start_y;
  }

  getSelectedBBox (selected) {
    if (!selected) return;

    const bb = svgedit.utilities.getBBox(selected);
    const zoom = this.canvas.getZoom();

    let offset = 1.0 / zoom;

    const sw = selected.getAttribute('stroke-width');
    if (selected.getAttribute('stroke') !== 'none' && !isNaN(sw)) {
      offset += (sw / 2);
    }

    offset *= zoom;

    // 1 - is width of selection path
    return {
      x: (bb.x) + offset,
      y: (bb.y) + offset,
      width: bb.width - offset,
      height: bb.height - offset
    };
  }

  getSnappendCoordinates (dx, dy, getSnapPoint) {
    function snapToGrid (d, r, size) {
      let stepSize = this.canvas.curConfig.stepSize || 10;
      stepSize *= this.canvas.zoomMultiplier;

      // proposal coord
      d = Math.floor(d / stepSize) * stepSize;
      const p = r + stepSize;

      const distance = size / 2 - p;
      const delta = (((distance / stepSize) | 0) * stepSize - distance);
      return d - delta;
    }

    if (this.canvas.curConfig.gridSnapping) {
      let rs = [0 /* x */, 0];
      if (getSnapPoint) {
        rs = getSnapPoint.call(this);
      }

      dx = snapToGrid.call(this, dx, rs[0], this.canvas.contentW);
      dy = snapToGrid.call(this, dy, rs[1], this.canvas.contentH);
    }

    return [dx, dy];
  }

  update (r_mouse_x, r_mouse_y, event) {
    console.warn('Called abstract method');
  }

  destruct () {
    this.canvas.started = false;
  }
}
